import { Card, CardBody, CardTitle, CardSubtitle } from 'reactstrap';

const DashCards = ({ children, title, subtitle, actions }) => {
  return (
    <Card>
      <CardBody>
        <div className="d-md-flex">
          <div>
            <CardTitle tag="h4">{title}</CardTitle>
            <CardSubtitle className="text-muted">{subtitle}</CardSubtitle>
          </div>
          <div className="ms-auto mt-3 mt-md-0">{actions}</div>
        </div>
        <div className="mt-3">{children}</div>
      </CardBody>
    </Card>
  );
};



export default DashCards;
